import { PropsWithChildren } from 'react';
import { Area, AreaChart } from 'recharts';

import { BaseChart } from '../../BaseChart/BaseChart';
import { CubeChartBaseProps } from '../CubeChart.types';

export const CubeChartArea = <TData extends Record<string, any>>({
  resultSet,
}: PropsWithChildren<CubeChartBaseProps<TData>>) => {
  return (
    <BaseChart data={resultSet.chartPivot()} dataKey="x" chartComponent={AreaChart} legend tooltip>
      {({ colors }) => (
        <>
          {resultSet.seriesNames().map((series, i) => (
            <Area
              key={series.key}
              stackId="a"
              dataKey={series.key}
              name={series.title}
              type="linear"
              strokeWidth={3}
              stroke={colors[i]}
              fill={colors[i]}
              isAnimationActive={false}
              legendType="circle"
            />
          ))}
        </>
      )}
    </BaseChart>
  );
};
